// extracted by mini-css-extract-plugin
export default {"text-modal":"network-text_text-modal__1s109"};